import classes from './List.module.css';
import CountUp from 'react-countup';

const Item = (props) => {

    return (
        <div className={classes.item_container}>
<div className={classes.name}><h3>{props.name}</h3> <p>{props.description}</p></div>
<div className={classes.price}><CountUp end={props.price}  duration={2.5}/> T</div>
<div className={classes.icon}><img src={props.icon}></img></div>
        </div>
    )
}

export default Item;